import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { StyledQuestionReadyLinks } from "./index.styled";
import linkIcon from "../../../assets/icons/share.png";
import QuestionReadyLinkItem from "./QuestionReadyLinkItem";
import { getConfig, type AppConfig } from "../../../utils/config";

const getPublicQCopyUrl = (publicId: string) =>
  `${window.location.origin}/q/${publicId}`;

interface QuestionReadyLinksProps {
  publicId?: string;
  shortCode?: string;
}

const QuestionReadyLinks = ({
  publicId,
  shortCode,
}: QuestionReadyLinksProps) => {
  const navigate = useNavigate();
  const [config, setConfig] = useState<AppConfig | null>(null);

  useEffect(() => {
    void getConfig().then(setConfig);
  }, []);

  const copyUrl = publicId ? getPublicQCopyUrl(publicId) : undefined;
  const canViewResponses = Boolean(shortCode?.trim());
  const trimmedShort = shortCode?.trim();
  const whatsappCopyUrl =
    config?.WHATSAPP_PHONE_NUMBER_BOX && trimmedShort
      ? `https://wa.me/${config.WHATSAPP_PHONE_NUMBER_BOX}?text=${`תיבה ${trimmedShort}`.replaceAll(
          " ",
          "+",
        )}`
      : undefined;

  return (
    <StyledQuestionReadyLinks>
      <div className="links-header">
        <h3 className="links-title">קישורים</h3>
        <div className="links-header-divider" />
        <div className="title-icon-wrapper">
          <img
            src={linkIcon}
            alt=""
            aria-hidden="true"
            className="title-icon"
          />
        </div>
      </div>

      <QuestionReadyLinkItem
        title="קישור ציבורי לשליחת תגובות"
        subtitle="שתף את הקישור הזה עם הקהילה"
        copyUrl={copyUrl}
      />

      <div className="link-divider" />

      <QuestionReadyLinkItem
        title="קישור לתגובות דרך הבוט בוואטסאפ"
        subtitle="למשתמשים עם גישה חסומה"
        copyUrl={whatsappCopyUrl}
      />

      <button
        type="button"
        className="view-responses-button"
        disabled={!canViewResponses}
        onClick={() => {
          if (!shortCode?.trim()) return;
          navigate(`/anonymous/${shortCode.trim()}/responses`);
        }}
      >
        לצפיה בתגובות
      </button>
    </StyledQuestionReadyLinks>
  );
};

export default QuestionReadyLinks;
